import Axios from "axios";
import initializeConfig from "./api.config";
import { interceptorBeforeRequest, interceptorAfterResponse } from "./api.interceptors";

export const createAxiosInstance = (apiConfig) => Axios.create(apiConfig);

const Request = async () => {
  const { apiConfig } = await initializeConfig();
  const apiInstance = createAxiosInstance(apiConfig);

  interceptorBeforeRequest(apiInstance);
  interceptorAfterResponse(apiInstance);

  return {
    get: async (url: string, queryParams: any = {}) => {
      const getParams = { params: queryParams };
      return apiInstance.get(url, getParams);
    },
    post: (url: string, data?: any) => apiInstance.post(url, data),
    delete: (url: string, data?: any) => apiInstance.delete(url, { data: data }),
    put: (url: string, data?: any) => apiInstance.put(url, data),
  };
};

export const requestCsv = async () => {
  const { apiConfig } = await initializeConfig();
  const apiInstance = createAxiosInstance(apiConfig);

  interceptorBeforeRequest(apiInstance);
  interceptorAfterResponse(apiInstance);

  return {
    post: (url: string, data?: any) => {
      const config = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      return apiInstance.post(url, data, config);
    },
  };
};

export default Request();
